<template>
    <transition name="toaster-slide">
        <div id="toaster" class="normal-text" v-if="showing_toaster && toastStatus !== 'clear'" :class="toastStatus" @mouseover="stopTimer" @mouseleave="resetTimer" @click="dismiss()">
            <i class="fal fa-check-circle" v-if="toastStatus === 'success'"></i>
            <i class="fal fa-times" v-else-if="toastStatus === 'error'"></i>
            <i class="fal fa-exclamation-triangle" v-else-if="toastStatus === 'warn'"></i>
            <i class="fal fa-spinner fa-spin self-start lg:self-auto" v-else-if="toastStatus === 'busy'"></i>
            <div class="tw-flex tw-flex-col tw-pt-1 lg:tw-pt-0 xxl:tw-text-base">
                <h3 v-html="toast.title"></h3>
                <p class="tw-mt-1 tw-text-sm xxl:tw-text-normal">{{ toast.body }}</p>
            </div>
        </div>
    </transition>
</template>

<script>

    import Notification from '../../lib/models/Notification';

    export default {
        name: 'Toaster',

        data() {
            return {
                timer: 0,
                paused: false,
                showing_toaster: false,
                timer_is_decreasing: false,
            };
        },

        computed: {
            toast() {
                return Notification.query().last();
            },

            toastStatus() {
                return this.toast.status;
            },

            toasterTime() {
                if (this.toastStatus === 'busy') {
                    return 9999999;
                }

                return 3700;
            },
        },

        methods: {
            dismiss() {
                this.timer_is_decreasing = false;
                this.showing_toaster = false;
            },

            stopTimer() {
                this.timer_is_decreasing = false;
                this.timer = this.toasterTime;
                this.paused = true;
            },

            resetTimer() {
                const self = this;

                this.paused = false;
                this.timer_is_decreasing = true;

                const resetTimer = function resetTimer() {
                    if (!self.paused) {
                        self.timer = 0;
                    }
                };

                self.timer = self.toasterTime;

                window.setTimeout(resetTimer, self.toasterTime);
            },
        },

        watch: {
            toast() {
                this.showing_toaster = true;
                this.resetTimer();
            },

            timer(newVal) {
                if (newVal === 0) {
                    this.timer_is_decreasing = false;
                    this.showing_toaster = false;
                }
            },
        },
    };
</script>

<style lang="scss">
    #toaster {
        @apply tw-flex tw-items-center tw-fixed tw-bg-white tw-p-4 tw-cursor-pointer tw-opacity-100 tw-rounded-lg tw-shadow-light;
        z-index: 9999;
        bottom: 35px;
        min-width: 225px;
        right: 60px;
        clip-path: inset(-7px -5px -7px -5px);

        i {
            @apply tw-mr-3 #{!important};
            font-size: 30px;
            width: 30px;
            height: 30px;
        }

        b {
            font-weight: 600;
        }

        &.success {
            i {
                @apply tw-text-green-500;
            }
        }

        &.error {
            i {
                @apply tw-text-red-500;
                width: 18.5px;
            }
        }

        &.warn {
            i {
                @apply tw-text-orange-500;
            }
        }

        &.busy {
            i {
                font-size: 23px;
                width: 23px;
                height: 23px;
            }
        }

        @media(max-width: 1100px) {
            right: 15px;
            bottom: 67px;
        }
    }

    .toaster-slide-enter-active {
        transition: transform .3s, opacity .4s, right .3s, bottom .3s, clip-path .2s;
        transition-delay: .2s;
    }

    .toaster-slide-leave-active {
        transition: opacity .15s, right .15s, bottom .15s, clip-path .15s;
    }

    .toaster-slide-enter, .toaster-slide-leave-to {
        opacity: 0 !important;
        bottom: 25px !important;

        @media(max-width: 1100px) {
            bottom: 57px !important;
        }
    }

    .toaster-slide-enter {
        transform: scale(0.8);
        right: 80px !important;
        clip-path: inset(100% 100% -7px -5px) !important;

        @media(max-width: 1100px) {
            right: 35px !important;
        }
    }

    .toaster-slide-leave-to {
        clip-path: inset(100% -5px -7px 100%) !important;
    }

    .toaster-slide-enter-to, .toaster-slide-leave {
        opacity: 1 !important;
        transform: scale(1);
        right: 60px !important;
        bottom: 35px !important;
        clip-path: inset(-7px -5px -7px -5px) !important;

        @media(max-width: 1100px) {
            bottom: 67px !important;
            right: 15px !important
        }
    }
</style>
